import { createSlice } from "@reduxjs/toolkit";
import { deleteBatch, getFiles, importFile } from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  files: [],
  uploadfile: null,
  loading: false,
  error: {},
};

const ProductsSlice = createSlice({
  name: "FilesSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getFiles.pending, (state, action) => {
      state.loading = true;
      state.files = [];
      state.error = {};
    });

    builder.addCase(getFiles.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.success) {
        state.files = action.payload.data;
      } else state.error = action.payload.message || null;
    });

    builder.addCase(getFiles.rejected, (state, action) => {
      toast.dismiss();
      state.error = action.payload.error || null;
    });

    builder.addCase(importFile.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Importing File...", {
        position: "top-center",
        autoClose: false,
      });
    });

    builder.addCase(importFile.fulfilled, (state, action) => {
      toast.dismiss();
      state.uploadfile = null;
      if (action.payload.success) {
        state.uploadfile = action.payload.data;
        toast.success("File imported Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else
        toast.error("Import File Failed", {
          position: "top-center",
          autoClose: 3000,
        });
    });

    builder.addCase(importFile.rejected, (state, action) => {
      toast.dismiss();
      //state.error = action.payload.message || null;
    });

    builder.addCase(deleteBatch.fulfilled, (state, action) => {
      toast.dismiss();
      if (action.payload.success) {
        state.files = state.files.filter(
          (file) => file.bai_id !== action.payload.data.bai_id
        );
        toast.success("File deleted Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else
        toast.error("Delete File Failed", {
          position: "top-center",
          autoClose: 3000,
        });
    });

    builder.addCase(deleteBatch.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Delete File Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      // state.error = action.payload.message || null;
    });

    builder.addCase(deleteBatch.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Deleting File...", {
        position: "top-center",
        autoClose: false,
      });
    });
  },
});

export default ProductsSlice.reducer;
